// extracted by mini-css-extract-plugin
export default {"projectDescription":"projectForm_projectDescription__Ko3Mx"};